// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentWithAside-module__container--Rqffw","content":"ContentWithAside-module__content--3WA4v","aside":"ContentWithAside-module__aside--1htTe"};